import {ProductOfferDetail} from 'models';
import {ESortingActions} from 'modules/products/providers/CatalogPageProvider/types';
import {ESortingActions as ESortingActionsNew} from 'modules/products/providers/CatalogPageProvider/types';
import {TCatalogResizingMap} from 'modules/products/types';
import {adaptive} from 'styles/mixins/Adaptive';
import {SelectTooltipOption} from 'modules/products/components/SelectTooltipOption';

export const PRODUCT_TYPE: {
    [K in Exclude<ProductOfferDetail['type'], 'offline-wish'>]: K;
} & {
    offline: 'offline-wish';
} = {
    collection: 'collection',
    offline: 'offline-wish',
    simple: 'simple',
    technical: 'technical',
    visual: 'visual',
};

export const AUTH_MODAL_FORM_TYPE = {
    product: 'product',
    simple: 'simple',
} as const;

export const PRODUCT_LIST_VIEW = {
    list: 'list',
    tile: 'tile',
} as const;

export const PRODUCT_CARD_VARIANT = {
    auto: 'auto',
    bestSelling: 'bestSelling',
    main: 'main',
    preview: 'preview',
    previewVisual: 'previewVisual',
    searchRecommend: 'searchRecommend',
    similar: 'similar',
} as const;

export const CATALOG_LISTING_IMAGE_RESIZING_MAP: TCatalogResizingMap = {
    collection: [],
    mixed: [],
    simplelist: [
        {
            defaultSize: true,
            imageSize: {
                height: 100,
                width: 100,
            },
            screenWidth: adaptive.SIZE_XL_MIN,
        },
    ],
    simplepreview: [
        {
            defaultSize: true,

            imageSize: {
                height: 207,
                width: 207,
            },
            screenWidth: adaptive.SIZE_XL_MIN,
        },
        {
            imageSize: {
                height: 207,
                width: 207,
            },
            screenWidth: adaptive.SIZE_SM_MIN,
        },
    ],
    simpletile: [
        {
            defaultSize: true,

            imageSize: {
                height: 322,
                width: 322,
            },
            screenWidth: adaptive.SIZE_XL_MIN,
        },
        {
            imageSize: {
                height: 282,
                width: 282,
            },
            screenWidth: adaptive.SIZE_LG_MIN,
        },
        {
            imageSize: {
                height: 274,
                width: 274,
            },
            screenWidth: adaptive.SIZE_SM_MIN,
        },
    ],
    technical: [],
    visual: [
        {
            defaultSize: true,

            imageSize: {
                height: 322,
                width: 322,
            },
            screenWidth: adaptive.SIZE_XL_MIN,
        },
        {
            imageSize: {
                height: 282,
                width: 282,
            },
            screenWidth: adaptive.SIZE_LG_MIN,
        },
        {
            imageSize: {
                height: 274,
                width: 274,
            },
            screenWidth: adaptive.SIZE_SM_MIN,
        },
    ],
};

export const BATHROOM_FURNITURE_ID_60_74 = 30153;

export const SAFE_PRODUCT_PAGE_LOCAL_STORAGE_KEY = '__product-page';

export const DEFAULT_SKELETON_CARD_COUNT = 10;

export const PRODUCT_REVIEWS_SORT_LIST = [
    {
        comment: '',
        isApplied: false,
        param: ESortingActions.NEW,
        title: 'Сначала новые',
    },
    {
        comment: '',
        isApplied: true,
        param: ESortingActions.POPULAR,
        title: 'Сначала популярные',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActions.HIGH,
        title: 'Сначала с высокой оценкой',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActions.LOW,
        title: 'Сначала с низкой оценкой',
    },
];

export const REVIEW_MARKS_AMOUNT = 5;

export const MIN_SLIDER_AMOUNT_NAV = 4;

export const VINTAGE_ITEMS_COUNT = 4;

export const MAX_SHOW_ARTICLES_COUNT = 3;

export const MAX_LIMIT_ARTICLES_COUNT = 6;

export const DEFAULT_RATING = 0;

export const INITIAL_PRODUCT_REVIEW_FORM_VALUES = {text: ''};

export const PRODUCT_REVIEW_HASH_PREFIX = 'review-';

export const PRODUCT_REVIEW_SCROLL_DELAY = 300;

export const PRODUCT_REVIEW_SCROLL_OFFSET = -80;

export const MAX_REVIEWS_SLIDES_AMOUNT = 5;

export const PLURAL_REVIEW_WORDS = ['отзыв', 'отзыва', 'отзывов'];

export const PLURAL_GRADE_WORDS = ['оценка', 'оценки', 'оценок'];

export const PLURAL_REVIEW_RATING_WORDS = ['оценки', 'оценок', 'оценок'];

export const UNKOWN_NAME = 'Винный аноним';

export const REVIEWS_PAGE_SIZE = 10;

export const CATALOG_PAGE_SIZE = 33;

export const SORT_LIST = [
    {
        comment: 'Сначала покажем лучшее по версии SimpleWine',
        isApplied: true,
        param: ESortingActionsNew.OUR_CHOICE,
        title: (
            <SelectTooltipOption
                content={'Выбор SimpleWine'}
                hintText={'Сначала покажем лучшее по версии SimpleWine'}
                hintPosition={'top-right'}
            />
        ),
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.POPULAR,
        title: 'Популярное',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.DISCOUNT,
        title: 'По размеру скидки',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.REVIEWS_RATING,
        title: 'По рейтингу покупателей',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.EXPERTS_RATING,
        title: 'По рейтингу экспертов',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.PRICE_UP,
        title: 'Сначала подешевле',
    },
    {
        comment: '',
        isApplied: false,
        param: ESortingActionsNew.PRICE_DOWN,
        title: 'Сначала подороже',
    },
    // {
    //     comment: '',
    //     isApplied: false,
    //     param: ESortingActionsNew.PURCHASE,
    //     title: 'По дате покупки',
    // },
];

export const PRODUCT_PROPERTY_CODE_ART = 'art';
export const PRODUCT_ART_LINK = '/catalog/vino/filter/art-1/';
